import { bianka, BIANKA_ACTIVITY_TYPES, logger } from '@fiverr-private/obs';
import { Click, ClickType } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { TailoredHomepageClick } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/tailored_homepage_click';
import { IClickData } from '../../../types';
import { CLICK } from './constants';

export const sendClickEvent = async (clickData: IClickData) => {
    try {
        const { pageCtxId } = getContext();

        await bianka.reportActivity<Click, TailoredHomepageClick>({
            event: {
                type: CLICK.EVENT_TYPE,
                clickType: ClickType.LEFT,
                element: {
                    name: clickData.page_element_name ?? 'general_click',
                    type: 0,
                },
            },
            page: {
                ctxId: pageCtxId,
                name: CLICK.PAGE_NAME,
            },
            additionalData: {
                message: {
                    eventSource: CLICK.EVENT_SOURCE,
                    subGroup: CLICK.SUB_GROUP,
                    action: {
                        type: CLICK.ACTION_TYPE,
                    },
                    imp: clickData.imp,
                    subCategory: clickData.sub_category,
                    nestedSubCategory: clickData.nested_sub_category,
                    tailoredHomepageAttributes: {
                        tabPosition: clickData.clicked_tab_data?.tab_position,
                        tabAsset: clickData.clicked_tab_data?.tab_asset,
                        tabLogic: clickData.clicked_tab_data?.tab_logic,
                        size: clickData.size,
                    },
                },
                type: TailoredHomepageClick,
            },
            type: BIANKA_ACTIVITY_TYPES.CLICK,
        });
    } catch (error: any) {
        logger.error(error, { description: 'Failed to send click event' });
    }
};
